/** Shared coverage-frame contract for satellite selection (camera + footprint). */

/** The layer whose tracks carry an orbital coverage footprint (satellites). */
export const SATELLITE_LAYER = 'space:satellites';

/** Inputs to frame a satellite together with its ground coverage footprint. */
export interface CoverageFrame {
  /** Sub-satellite point latitude (deg). */
  lat: number;
  /** Sub-satellite point longitude (deg). */
  lng: number;
  /** Closed footprint ring (true-scale ground horizon). */
  ring: google.maps.LatLngLiteral[];
  /** True-scale footprint ground radius (m). */
  groundRadiusMeters: number;
  /** Exaggerated 3D shell altitude of the satellite pin (m), as drawn on the map. */
  shellAltMeters: number;
}
